(() => {
  const selector = '[data-eu-withdrawal-open]';

  const openWithdrawalForm = (trigger) => {
    const withdrawalForm = window.EUWithdrawalForm;

    if (!withdrawalForm || typeof withdrawalForm.open !== 'function') return false;

    try {
      withdrawalForm.open(trigger);
      return true;
    } catch {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(selector);
    if (!trigger) return;

    event.preventDefault();

    if (openWithdrawalForm(trigger)) return;

    window.dispatchEvent(
      new CustomEvent('eu-withdrawal:open', {
        detail: { trigger },
      })
    );

    window.setTimeout(() => openWithdrawalForm(trigger), 800);
  });
})();
